module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lista-solicitud-vacaciones contenedor-interno"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v(_vm._s(_vm.codigoEmpleado ? 'Libros de vacaciones' : 'Mis libros de vacaciones'))]), _c('span', {
    staticClass: "icon close",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])]), _c('div', {
    staticClass: "body"
  }, [_c('table', {
    staticClass: "table is-striped is-bordered"
  }, [_vm._m(0), _c("transition-group", {
    tag: "tbody",
    attrs: {
      "name": "table-row"
    }
  }, _vm._l((_vm.libros), function(o, index) {
    return _c('tr', {
      key: index,
      staticClass: "row-table",
      class: {
        active: o.activo
      },
      on: {
        "click": function($event) {
          return _vm.mostrarHojas(o)
        }
      }
    }, [_c('td', [_vm._v(_vm._s(o.periodo))]), _c('td', [_c('div', {
      staticClass: "td-wrapper hint--top",
      attrs: {
        "aria-label": 'Libro: ' + o.id
      }
    }, [_c('div', {
      staticClass: "dates-wrapper"
    }, [_c('span', [_vm._v(_vm._s(o.fechaInicio))]), _c('span', {
      staticClass: "hide-break-1"
    }, [_vm._v(" - ")]), _c('span', [_vm._v(_vm._s(o.fechaFin))])])])]), _c('td', [_vm._v(_vm._s(o.diasPorTomar))]), _c('td', [_vm._v(_vm._s(o.diasTomados))])])
  }), 0)], 1), (_vm.isLoading) ? _c('loading') : _vm._e()], 1), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.periodoSeleccionado) ? _c('div', [_c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Detalle del libro " + _vm._s(_vm.periodoSeleccionado))])]), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.loadingHojas) ? _c('div', {
    key: "loading",
    staticClass: "loading"
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-spin fa-spinner"
  })])]) : _c('div', {
    key: "list-hojas",
    staticClass: "hojas"
  }, [(_vm.hojas.length === 0) ? _c('article', {
    key: "message-not-hojas",
    staticClass: "message"
  }, [_c('div', {
    staticClass: "message-body"
  }, [_vm._v("No hay hojas en este libro")])]) : _c('div', {
    key: "table-hojas",
    style: (_vm.codigoEmpleado ? 'overflow-y: auto; height:10em;' : '')
  }, [_c('table', {
    staticClass: "table is-striped is-bordered detalle-wrapper"
  }, [_c('thead', [_c('th', [_vm._v("Fecha")]), _c('th', [_vm._v("Dias tomados")]), _c('th', [_vm._v("Motivo")])]), _c("transition-group", {
    tag: "tbody",
    attrs: {
      "name": "table-row"
    }
  }, _vm._l((_vm.hojas), function(o, index) {
    return _c('tr', {
      key: index,
      staticClass: "row-table",
      class: {
        resta: o.signo === '-', suma: o.signo === '+'
      }
    }, [_c('td', [_c('div', {
      staticClass: "td-wrapper hint--top",
      attrs: {
        "aria-label": 'Vacaciones: ' + o.idVacaciones
      }
    }, [_c('div', {
      staticClass: "dates-wrapper"
    }, [_c('span', [_vm._v(_vm._s(o.fechaInicio))]), _c('span', {
      staticClass: "hide-break-1"
    }, [_vm._v(" - ")]), _c('span', [_vm._v(_vm._s(o.fechaFin))])])])]), _c('td', [_vm._v(_vm._s(o.diasTomados))]), _c('td', [_vm._v(_vm._s(o.motivo))])])
  }), 0)], 1)])])])], 1) : _vm._e()])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Periodo")]), _c('th', [_vm._v("Inicio - Fin")]), _c('th', [_vm._v("Dias por tomar")]), _c('th', [_vm._v("Dias tomados")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-378dbfd2","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Component_Lista_Libros_Vacaciones.vue
// module id = 862
// module chunks = 0